/* eslint-disable no-redeclare */
import { Map } from "immutable";
import { STATE_STATUS, INITIATE_CASE_STATE } from "constants";
import _groupBy from "lodash/groupBy";
import { PAYPRO_CASE_NOTE_ACTIONS } from "constants/actions";
import { CaseNoteRecord } from "records/case-note-record";
import moment from "moment";

const INITIAL_STATE = new Map({});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case INITIATE_CASE_STATE:
        return state.set(
            payload.action_details_id,
            new Map({
                notes: new Map({}),
                status: STATE_STATUS.UNFETCHED,
                creating: false
            })
        );
    case PAYPRO_CASE_NOTE_ACTIONS.FETCH_PAYPRO_CASE_NOTES:
        return state.setIn(
            [payload.action_details_id, "status"],
            STATE_STATUS.FETCHING
        );
    case PAYPRO_CASE_NOTE_ACTIONS.FETCHED_PAYPRO_CASE_NOTES:
        // eslint-disable-next-line no-case-declarations
        let notes = payload.data.map(
            _ =>
                new CaseNoteRecord({
                    ..._,
                    create_date: moment(_.create_date),
                    create_date_string: moment(_.create_date).format("DD-MM-YYYY"),
                    state_status: STATE_STATUS.CREATED
                })
        );
        return state
            .setIn([payload.action_details_id, "status"], STATE_STATUS.FETCHED)
            .setIn(
                [payload.action_details_id, "notes"],
                new Map(_groupBy(notes, "create_date_string")).toOrderedMap().sort((a, b) => {
                    if(a[0].id > b[0].id) {
                        return -1;
                    }
                    if(a[0].id > b[0].id) {
                        return 1;
                    }
                    if(a[0].id === b[0].id) {
                        return 0;
                    }
                })
            );
    case PAYPRO_CASE_NOTE_ACTIONS.FAILED_FETCH_PAYPRO_CASE_NOTES:
        return state.setIn(
            [payload.action_details_id, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    default:
        return state;
    }
};
